import { setShowSupplierItemModal } from '../State/showSupplierItemModal';
import { setSupplierItemForEdit } from '../State/supplierItemForEdit';

export default () => async (dispatch) => {
  dispatch(setShowSupplierItemModal(false));
  dispatch(setSupplierItemForEdit(null));
}
